import { get } from '..';

const getSolveTags = (assetId: string) => get(`assets/${assetId}/solve-tags`);

export default getSolveTags;
